import React from 'react'
import Navbar from './Components/Navbar';
import HeroPage from './Components/HeroHome';
import Footer from './Components/Footer';

const Home = () => {
  return (
    <div>
        <Navbar />
        <HeroPage />
        <Footer />
    </div>
  )
}

export default Home;